import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { supportWidgetApi } from "@circle-react/api/supportWidgetApi";
import { BodySm } from "@circle-react-shared/uikit/Typography/components/Body/BodySm";
import { LabelMd } from "@circle-react-shared/uikit/Typography/components/Label/LabelMd";
import { BooleanButton } from "./common/BooleanButton";
import { NeedHelpWidget } from "./common/NeedHelpWidget";

export const FeedbackSection = ({ post }: { post: { id: string } }) => {
  const [isFeedbackPositive, setIsFeedbackPositive] = useState<boolean | null>(
    null,
  );
  const [isFeedbackGiven, setIsFeedbackGiven] = useState(false);

  const { mutate: createPostFeedback } = useMutation(
    ({ postId, value }: { postId: string; value: boolean }) =>
      supportWidgetApi.createPostFeedback({
        postId: postId,
        helpful: value,
      }),
  );

  const handleFeedback = (value: boolean) => {
    if (isFeedbackGiven) return;

    setIsFeedbackPositive(value);
    createPostFeedback({ postId: post.id, value });
    setIsFeedbackGiven(true);
  };

  useEffect(() => {
    if (isFeedbackPositive !== null) {
      document.getElementById("feedback-response-container")?.scrollIntoView();
    }
  }, [isFeedbackPositive]);

  return (
    <div className="mx-auto w-full pt-4">
      <div className="mb-6">
        <LabelMd weight="semibold">
          {t("support_widget.was_this_article_helpful")}
        </LabelMd>
      </div>
      <div className="mb-6 flex justify-center gap-4">
        <BooleanButton
          value={isFeedbackPositive}
          handleFeedback={handleFeedback}
          isFeedbackGiven={isFeedbackGiven}
        />
      </div>
      <div id="feedback-response-container">
        {isFeedbackPositive && (
          <div className="mb-2">
            <BodySm>
              {t("support_widget.thank_you_for_article_feedback")}
            </BodySm>
          </div>
        )}
        {isFeedbackPositive === false && (
          <div className="w-full">
            <NeedHelpWidget
              helpText={t("help_widget.post.still_need_help")}
              buttonText={t("help_widget.post.ask_a_question")}
            />
          </div>
        )}
      </div>
    </div>
  );
};
